export const FEEDBACK_RATING_SCALE = [
	{ score: 1, label: "Strongly Disagree" },
	{ score: 2, label: "Disagree" },
	{ score: 3, label: "Neutral" },
	{ score: 4, label: "Agree" },
	{ score: 5, label: "Strongly Agree" },
] as const;

export function feedbackQuestionNeedsRating(question: { required?: boolean } | null | undefined): boolean {
	return question?.required !== false;
}

export function feedbackQuestionNeedsAnswer(question: { answerEnabled?: boolean } | null | undefined): boolean {
	return question?.answerEnabled !== false;
}

export function feedbackQuestionAnswerRequired(
	question: { answerEnabled?: boolean; answerRequired?: boolean } | null | undefined,
): boolean {
	return feedbackQuestionNeedsAnswer(question) && question?.answerRequired === true;
}
